export const SELECT = 'SELECT_BREED';
export const DEFAULT = 'DEFAULT_BREED';
export const FETCH_DATA_PENDING = 'FETCH_DATA_PENDING_BREED';
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS_BREED';
export const FETCH_DATA_ERROR = 'FETCH_DATA_ERROR_BREED';

export function fetchDataPending() {
  return {
    type: FETCH_DATA_PENDING
  }
}

export function fetchDataSuccess(data) {
  return {
    type: FETCH_DATA_SUCCESS,
    data: data
  }
}

export function fetchDataError(error) {
  return {
    type: FETCH_DATA_ERROR,
    error: error
  }
}
